import { TableHeadingCell, withTableHeadingAccessibility, } from "./TableHeadingCell.mjs.mjs";
export const TableColumnHeadingCell = withTableHeadingAccessibility(TableHeadingCell, { role: 'columnheader', scope: 'col', displayName: 'TableColumnHeadingCell' });
//# sourceMappingURL=TableColumnHeadingCell.mjs.mjs.map